const renderComplete = (success = true) => {
    if (window?.webkit?.messageHandlers?.renderComplete) {
        window.webkit.messageHandlers.renderComplete.postMessage(success)
    } else if (typeof Android !== "undefined" && Android?.renderComplete) {
        Android.renderComplete(success)
    } else {
        console.debug(`Send "renderComplete(${success})" to app`)
    }
}

export {renderComplete}